import App from '@/app';

import { isDevelopment } from '@/utils/env';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.css';

import { commonOptionsAtom, loadCommonOptions } from '@/atoms/commonOptions';
import { useAtom } from 'jotai';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { ConfigProvider } from 'antd';

dayjs.locale('zh-cn');

const rootElement = document.getElementById('root');
const queryClient = new QueryClient();

// 创建一个包装组件来初始化数据
const AppWrapper = () => {
  const [, setCommonOptions] = useAtom(commonOptionsAtom);

  React.useEffect(() => {
    loadCommonOptions(setCommonOptions);
  }, [setCommonOptions]);

  return (
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  );
};

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppWrapper />
        {isDevelopment() && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </React.StrictMode>
  );
}
